import { Anchor } from "ant-design-vue";
const { ...other } = Anchor;
const YwAnchor = {
  ...other,
  name: "YwAnchor",
};

YwAnchor.install = function (Vue) {
  Vue.component(YwAnchor.name, YwAnchor);
};

export default YwAnchor;